const SENTRY_HUBS_KEY = 'sentryHubs';
const SENTRY_MAIN_HUB_KEY = 'sentryMainHub';
const SENTRY_GLOBAL_HUB_KEY = 'sentryGlobalHub';
const getHubMap = globalConfig => {
  if (!globalConfig.getStateValue(SENTRY_HUBS_KEY)) {
    globalConfig.setStateValue(SENTRY_HUBS_KEY, new Map());
  }
  return globalConfig.getStateValue(SENTRY_HUBS_KEY);
};
export const getMainHub = globalConfig => globalConfig.getStateValue(SENTRY_MAIN_HUB_KEY) ?? null;
export const setMainHub = (hub, globalConfig) => globalConfig.setStateValue(SENTRY_MAIN_HUB_KEY, hub);
export const getGlobalHub = globalConfig => globalConfig.getStateValue(SENTRY_GLOBAL_HUB_KEY) ?? null;
export const setGlobalHub = (hub, globalConfig) => globalConfig.setStateValue(SENTRY_GLOBAL_HUB_KEY, hub);
export const getHubForArtifact = (artifactId, globalConfig) => getHubMap(globalConfig).get(artifactId) ?? null;
export const setHubForArtifact = (hub, artifactId, globalConfig) => getHubMap(globalConfig).set(artifactId, hub);
export const getHubForDsn = (dsn, globalConfig) => getHubMap(globalConfig).get(dsn) ?? null;
export const setHubForDsn = (hub, dsn, globalConfig) => getHubMap(globalConfig).set(dsn, hub);
//# sourceMappingURL=sentry-plugin-state.js.map